import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, ReplaySubject } from 'rxjs';
import { UserResource } from 'vipbc';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private _user: ReplaySubject<UserResource> = new ReplaySubject<UserResource>(1);

    constructor(private _httpClient: HttpClient) {
    }

    set user(value: UserResource) {
        // Store the value
        this._user.next(value);
    }

    get user$(): Observable<UserResource> {
        return this._user.asObservable();
    }

    update(user: UserResource): Observable<any> {
        return this._httpClient.patch<UserResource>('api/common/user', { user }).pipe(
            map((response) => {
                this._user.next(response);
            })
        );
    }
}
